<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Pedidos</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Pedidos</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <div class="row  justify-content-center">
            <div class="col-xl-3 col-lg-12">
                <div class="card card-dark">
                    <div class="card-header">
                        <h2 class="card-title">Filtro</h2>
                    </div>
                    <div class="card-body">
                        <form [formGroup]="filterForm">
                            <app-datepicker-range label="Fecha Ingreso" idForm="FecIngreso"
                                [controlTo]="filterForm.get('fechaIngresoTo')"
                                [controlFrom]="filterForm.get('fechaIngresoFrom')"
                                [bsRangeValue]="bsRangeValue"></app-datepicker-range>
                            <app-datepicker-range label="Fecha Termino" idForm="FecEntrega"
                                [controlTo]="filterForm.get('fechaEntregaTo')"
                                [controlFrom]="filterForm.get('fechaEntregaFrom')"></app-datepicker-range>
                            <app-select label="Estado" idForm="InputState" size="lg"
                                [control]="filterForm.get('estado')" [data]="estados" optValue="id_estado"
                                optText="nombre_estado" [default]="true" defValue="null"></app-select>
                            <!-- <div class="form-group">
                            <label for="entregado">Incluye Entregado</label>
                            <div class="custom-control pl-0">
                                <input type="checkbox" data-toggle="switch" data-size="large" data-on-text="SI" data-off-text="NO" data-handle-width="auto" id="InputEntregado" name="InputEntregado" onchange="CheckEntregado();">                          
                            </div>
                            <input type="hidden" id="InputEntregado_val" name="InputEntregado_val" />
                        </div> -->
                            <div class="row justify-content-center">
                                <div class="col-md-12">

                                    <button type="button" class="btn btn-outline-success btn-block btn-lg"
                                        (click)="getData()" [disabled]="!filterForm.valid">
                                        <i class="fas fa-angle-double-down"></i> Filtrar
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div class="col-xl-9 col-lg-12">
                <app-lista-pedidos label="Todos los pedidos" (updateData)="getData()" [rows]="rows" [tempRows]="rows"
                    [isLoading]="isLoading" [sortByKey]="'id_pedido'" [reverseSort]="true"></app-lista-pedidos>
            </div>
        </div>
    </div>
</section>